// See README.md for more info about field configuration

import {
  FIELD_TYPE,
  CONFLICT_ALERTING,
  MATCH,
  DATASET,
  YES_NO,
  AUTHORISED_TO
} from '@/constants'
import { getContactText, getContactNumberFields } from './helpers'
import UTILS from '@/store/utils'
import store from '@/store/store'

export default [
  // EMERGENCY CONTACTS -------------------------------------------
  {
    apiKey: 'emergencyContact',
    type: FIELD_TYPE.COLLECTION,
    heading(contact) {
      if (contact) {
        const fullName = UTILS.toFullNameString(
          contact.contactFirstName,
          contact.contactFamilyName
        )
        return `Emergency contact: ${fullName}`
      }
      return `Emergency contact`
    },
    summaryText(contact) {
      var relationship = store.getters.lookupCode(
        DATASET.RELATIONSHIP,
        contact.contactRelationship
      )
      const fullName = UTILS.toFullNameString(
        contact.contactFirstName,
        contact.contactFamilyName
      )
      return `${fullName}${relationship ? `, ${relationship}` : ''}`
    },
    orderBy: 'priority',
    addLabel: 'Add emergency contact',
    newRecordTemplate() {
      return {
        contactFamilyName: '',
        contactFirstName: '',
        contactRelationship: '',
        contactDetails: [
          {
            contactType: '',
            contactValue: '',
            comments: ''
          }
        ]
      }
    },
    conflictAlerting: CONFLICT_ALERTING.AB,
    ernMatch(oes, ern) {
      return UTILS.isMatch(oes, ern, {
        contactFirstName: MATCH.FUZZY,
        contactFamilyName: MATCH.FUZZY
      })
    },
    ernRecordNumberField: 'ernEmergencyContactRecordNo',
    oesRecordNumberField: 'contactRecordNo',
    fields(apiKeyPrefix, contact) {
      const isReolvedAsList = UTILS.isEmergencyContactDetailsResolved(
        store.state.application,
        contact
      )

      return [
        {
          apiKey: apiKeyPrefix + 'contactFamilyName',
          label: 'Family name',
          required: true,
          type: FIELD_TYPE.NAME,
          maxlength: 100
        },
        {
          apiKey: apiKeyPrefix + 'contactFirstName',
          label: 'Given name',
          required: false,
          type: FIELD_TYPE.NAME,
          maxlength: 100
        },
        {
          apiKey: apiKeyPrefix + 'contactRelationship',
          label: 'Relationship to student',
          required: true,
          type: FIELD_TYPE.DROPLIST,
          dataset: DATASET.RELATIONSHIP
        },

        // EMERGENCY CONTACT NUMBERS -------------------------------------------
        {
          apiKey: apiKeyPrefix + 'contactDetails',
          type: FIELD_TYPE.COLLECTION,
          conflictAlerting: isReolvedAsList
            ? CONFLICT_ALERTING.LIST
            : CONFLICT_ALERTING.AB_GROUP_CONTACT,
          ernRecordNumberField: 'ernContactDetailRecordNo',
          oesRecordNumberField: 'contactDetailRecordNo',
          showKeepRemoveOptions: !isReolvedAsList,
          heading(contactNumber) {
            return getContactText(contactNumber)
          },
          placeholderTitle: 'Contact details',
          orderBy: 'priority',
          addLabel: 'Add contact number',
          newRecordTemplate() {
            return {
              contactType: '',
              contactValue: '',
              comments: ''
            }
          },
          ernMatch(oes, ern) {
            return UTILS.isMatch(oes, ern, {
              contactValue: MATCH.FUZZY_CONTACT
            })
          },
          fields(apiKeyPrefix, contactNumber) {
            return getContactNumberFields(
              this.apiKey,
              contactNumber,
              apiKeyPrefix,
              true,
              null,
              parent
            )
          }
        },
        // EMERGENCY CONTACT ADDRESS -------------------------------------------
        {
          apiKey: apiKeyPrefix + 'contactAddress',
          label: 'Address',
          type: FIELD_TYPE.ADDRESS,
          default: {},
          ernRecordNumberField: 'ernContactAddressRecordNo',
          oesRecordNumberField: 'contactAddressRecordNo',
          visible(application) {
            return application.scholasticYear === 'P'
          }
        },
        // IS AUTHORISED TO -------------------------------------------
        ...AUTHORISED_TO.map((authorisedTo) => ({
          apiKey: apiKeyPrefix + authorisedTo.value,
          label: `Authorised to ${authorisedTo.text}?`,
          type: FIELD_TYPE.RADIO,
          options: YES_NO,
          // These consent answers are always taken from OES, even if ERN
          // were ever to return a differing value for them.
          noConflictAlerting: true,
          visible(application) {
            return application.scholasticYear === 'P'
          }
        }))
      ]
    }
  },
  {
    type: FIELD_TYPE.CUSTOM,
    component: 'InfoPanel',
    componentProps: {
      content: `<span style="line-height: 24px"><b>Note: </b>Parent/Carer has not provided two emergency contacts.<span>`,
      isAlertMessage: true
    },
    visible(application) {
      return application.emergencyContact.length < 2
    },
    readOnly: true
  }
]
